import type {LoaderFunctionArgs} from 'react-router'
import {useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../../helpers/navigationStateCache.ts'
import {withThirdPartiesParam} from '../../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import NewsListComponentRaw from './index.js'

import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const NewsListComponent = withThirdPartiesParam(NewsListComponentRaw)

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`
  const routeInfo = {
    location: {
      pathname,
      query: Object.fromEntries(url.searchParams.entries()),
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {
      category: params.category,
      tag: params.tag
    }
  }
  const data = await getInitialProps({routeInfo, context})
  return data
}

export function Component() {
  const data = useLoaderData()
  return <NewsListComponent {...data} />
}
